import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { ReactElement, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { businessStartQuestionQuery } from '@/__generated__/businessStartQuestionQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { StartBusinessContainer } from '@/components/survey/business/start-business/StartBusinessContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { startBusinessQuery } from '@/graphql/query/survey/business';
import { currentBusinessBmanTinAtom, refundHistoryIdAtom } from '@/lib/stores/survey/common';

function SurveyStartBusinessPage() {
  const eventAttributes = useSurveyUserEventAttributes();

  const [queryRef, loadQuery] = useQueryLoader<businessStartQuestionQuery>(startBusinessQuery);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const currentBusinessBmanTin = useAtomValue(currentBusinessBmanTinAtom);

  useEffect(() => {
    if (refundHistoryId && currentBusinessBmanTin) {
      loadQuery(
        {
          refundHistoryId,
          bmanTin: currentBusinessBmanTin
        },
        { fetchPolicy: 'network-only' }
      );
    }
  }, [loadQuery, refundHistoryId, currentBusinessBmanTin]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_start-business-directly'} eventProperty={eventAttributes}>
      <StartBusinessContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

SurveyStartBusinessPage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>{page}</BusinessProvider>
  </SurveyProvider>
);

export default SurveyStartBusinessPage;
